(() => {
  const SECTION_SELECTOR = '[data-why-grow-kelpedge-section]';
  const VALUE_SELECTOR = '.js-why-grow-kelpedge-value';

  function parseTarget(rawValue) {
    const normalized = String(rawValue || '0').replace(/,/g, '').trim();
    const parsed = Number.parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function inferPrecision(rawValue) {
    const normalized = String(rawValue || '0').replace(/,/g, '').trim();
    const match = normalized.match(/\.(\d+)/);
    return match ? match[1].length : 0;
  }

  function formatValue(value, precision, digitCount) {
    const safeValue = Number.isFinite(value) ? value : 0;
    const safeDigitCount = Math.max(Number.isInteger(digitCount) ? digitCount : 1, 1);
    const sign = safeValue < 0 ? '-' : '';
    const abs = Math.abs(safeValue);

    if (precision > 0) {
      const fixed = abs.toFixed(precision);
      const parts = fixed.split('.');
      return `${sign}${parts[0].padStart(safeDigitCount, '0')}.${parts[1]}`;
    }

    return `${sign}${String(Math.round(abs)).padStart(safeDigitCount, '0')}`;
  }

  function animateCounter(el) {
    if (!el || el.dataset.animated === 'true') return;

    const rawTarget = el.dataset.target || '0';
    const target = parseTarget(rawTarget);
    const precision = inferPrecision(rawTarget);
    const digitCount = Math.max(Number.parseInt(el.dataset.digitCount || '1', 10), 1);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = formatValue(target, precision, digitCount);
      el.dataset.animated = 'true';
      return;
    }

    const startTime = performance.now();
    const duration = 1200;

    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = precision > 0 ? target * eased : Math.round(target * eased);

      el.textContent = formatValue(current, precision, digitCount);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      } else {
        el.textContent = formatValue(target, precision, digitCount);
        el.dataset.animated = 'true';
      }
    };

    window.requestAnimationFrame(tick);
  }

  function setInitialCounterValue(el) {
    if (!el || el.dataset.initialized === 'true') return;

    const rawTarget = el.dataset.target || '0';
    const precision = inferPrecision(rawTarget);
    const digitCount = Math.max(Number.parseInt(el.dataset.digitCount || '1', 10), 1);

    el.textContent = formatValue(0, precision, digitCount);
    el.dataset.initialized = 'true';
    el.dataset.animated = 'false';
  }

  function initSection(sectionRoot) {
    if (!sectionRoot) return;

    const counters = Array.from(sectionRoot.querySelectorAll(VALUE_SELECTOR));
    if (!counters.length) return;

    counters.forEach(setInitialCounterValue);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.35,
      }
    );

    counters.forEach((counter) => observer.observe(counter));
  }

  function initAll(root = document) {
    const sections = Array.from(root.querySelectorAll(SECTION_SELECTOR));
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:reorder', () => initAll(document));
  }
})();
